import React, { useState } from "react";
import styles from "./styles.module.css";
import { AnimalSaleMap } from "../animalsalemap/index";
// import { Sidebar } from "../../../components/mainsidebar/ui/buttonsNavigate";
import { 
    ProductTable, 
    SalesTotaltypesOfproducts, 
  } from "../../../components/tables/index";
  import ProductAnimalChart from "../../tables/animaltables/salesanimal/table2";
  import AnimalSalesChart from "../../tables/animaltables/salesanimal/table1";
  import MilkSaleChart from "../../tables/animaltables/salesanimal/milk";
  import MeatSaleChart from "../../tables/animaltables/salesanimal/meat";
  import EggSaleChart from "../../tables/animaltables/salesanimal/egg";
  import WoolSaleChart from "../../tables/animaltables/salesanimal/wool";
import styled from "styled-components";
import { Button } from "antd";

const Container = styled.div`
  position: relative;
  height: 100vh;

`;

const Content = styled.div`

`;

const ButtonContainer = styled.div`
  position: fixed;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 999;
`;

export const AnimalSale = () => {
  const [collapsed, setCollapsed] = useState(false);

  
  const [activeTab, setActiveTab] = useState<"map" | "statistics">("map");

 
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };


  const handleTabChange = (tab: "map" | "statistics") => {
    setActiveTab(tab);
  };

  return (
    <Container>
      {/* <Sidebar collapsed={collapsed} /> */}
      <Content>
        <ButtonContainer>
          <Button
            type={activeTab === "map" ? "primary" : "default"}
            onClick={() => handleTabChange("map")}
          >
            Карта
          </Button>
          <Button
            type={activeTab === "statistics" ? "primary" : "default"}
            onClick={() => handleTabChange("statistics")}
          >
            Статистика и аналитика
          </Button>
        </ButtonContainer>

        {activeTab === "map" ? (
          <div className={styles.mapBackground}>
            <AnimalSaleMap latitude={41.5089324} longitude={74.724091} />
            <SalesTotaltypesOfproducts />
            <ProductTable/>
          </div>
        ) : (
            <div className={styles.tables_animal_sale}>
          <AnimalSalesChart />
          <ProductAnimalChart/>
          <MilkSaleChart/>
          <MeatSaleChart/>
          <EggSaleChart/>
          <WoolSaleChart/>
        
         </div>
        )}
      </Content>
    </Container>
  );
};
